let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("69Svh")).then(() => parcelRequire('gEw1T'));